var _defs, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack193({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-miterlimit:10;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M11.78,10.22l.8-3.8H11.17l.1-.49h3.38l-.1.49h-1.4l-.79,3.8Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 5,
    cy: 8,
    r: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack193);
export default __webpack_public_path__ + "static/media/Symbolpack_1_93.12c65c75e12e9d069700868ae91896ce.svg";
export { ForwardRef as ReactComponent };